
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.322 6.052a3.523 3.523 0 01-2.506 1.038c-.947 0-1.837-.369-2.507-1.038L8.201 4.943l.932-.931L10.24 5.12c.42.42.98.651 1.575.651a2.228 2.228 0 000-4.452c-.596 0-1.154.231-1.575.651L9.133 3.08l-.465.466-.933.933-.467.465L6.16 6.052A3.522 3.522 0 013.654 7.09c-.947 0-1.837-.369-2.507-1.038A3.523 3.523 0 01.108 3.545c0-.946.37-1.837 1.04-2.506A3.522 3.522 0 013.653 0C4.6 0 5.49.37 6.16 1.039l1.108 1.108-.932.932L5.228 1.97c-.42-.42-.98-.65-1.574-.65a2.21 2.21 0 00-1.574.65 2.212 2.212 0 00-.652 1.575c0 .594.23 1.154.652 1.573.421.422.98.653 1.574.653.595 0 1.154-.23 1.574-.651l1.108-1.108.465-.467.934-.933.466-.465L9.31 1.039A3.523 3.523 0 0111.816 0c.946 0 1.837.37 2.506 1.039a3.55 3.55 0 010 5.013z","fill":"#828282"}})])
          )
        }
      }
    